(function () {
    'use strict';

    // @ngInject
    function AppcuesServiceCtor(ExceptionService, AppConfigService, DeviceService, FeaturesService, $window, TrackJS) {
        this.ExceptionService = ExceptionService;
        this.AppConfigService = AppConfigService;
        this.TrackJS = TrackJS;
        this.Appcues = $window.Appcues;
        this.DeviceService = DeviceService;
        this.FeaturesService = FeaturesService;
    }


    Services.AppcuesService = Class(function () {
        return {
            constructor: AppcuesServiceCtor,

            initTracking: function initTracking(user) {
                if (this.shouldTrack(user)) {
                    try {
                        this.Appcues.identify(user._id,
                            { // Unique identifier for current user
                            first_name: user.first_name, // current user's name
                            email: user.email, // Current user's email
                            created_date: user.created_at, // Unix timestamp of user signup date
                            trial_start_date: user.getTrialStartDate(), // Current user’s start trial date
                            is_in_trial:  user.isInTrial(), // Current user’s is in trail period
                            is_subscribed : user.companyHasSubscription(),
                            user_type: user.system_user_type, // Current user’s type vendor/client
                            is_desktop: !this.DeviceService.nxSmallBreakpoint(), // Current user’s device size in this sesion
                            segment_prediction: user.account.predicted_member_segment,
                            calendly_integrated: !!user.calendly_integration , // user has calendly integration
                            instant_booking_gift_card: user.isFeatureActive(this.FeaturesService.rolloutFeatures.instantBookingGiftCards) , // is instant booking gift card enabled for user
                        });
                    } catch (e) {
                        this.TrackJS && this.TrackJS.track(e);
                    }
                }
            },
            shouldTrack: function shouldTrack(user) {
                var trackByUser = true;
                if (user)
                {
                    // We only care that that the user has/had a trial object to turn off for vendors that never started a trial (atws etc...)
                    trackByUser = user.isVendor() && (user.companyHasSubscription() || !!user.getTrial());
                }
                return this.Appcues &&
                       trackByUser &&
                       (this.AppConfigService.appConfiguration().environment === 'production' || this.AppConfigService.appConfiguration().environment === 'staging');

            },

            trackPageView: function trackPageView() {
                if (this.Appcues && this.shouldTrack()){
                    this.Appcues.page();
                }
            },

            trackEvent: function trackEvent(eventName, user) {
                if (this.Appcues && this.shouldTrack(user)){
                    this.Appcues.track(eventName);

                }
            }
        };
    });

}());
